/* global ReactSpringserveComponent */

//TODO: consolidate with app/javascript/scripts/angular/components/bulkBudgetChangeModal.js to create a shared template for bulk modals that use React components

angular.module("vastdesk").component("bulkFlightDateChangeModal", {
  bindings: {
    type: "@",
    targetTableId: "@",
  },
  template: require("../templates/bulkFlightDateChangeModal.html"),
  controllerAs: "$bulkFlightDateChangeModalCtrl",
  controller: [
    "$scope",
    "$rootScope",
    function ($scope, $rootScope) {
      const self = this;

      this.rootId = `component-root-angular-ModalBulkFlightDateChange-${Math.floor(
        Math.random() * 2 ** 52
      )}`;

      this.open = false;
      this.selectedIds = [];
      this.unregisterWatcher = null;

      this.handleBulkFlightDateChangeModalOpenChange = (open) => {
        self.open = open;
        $scope.$apply();
      };

      this.handleBulkFlightDateChangeSubmitted = () => {
        $scope.$apply();
        location.reload();
      };

      this.renderReactComponent = () => {
        return window.reactComponentScriptLoaded.promise.then(() => {
          ReactSpringserveComponent.renderComponent({
            componentName: "ModalBulkFlightDateChange",
            rootId: self.rootId,
            componentProps: {
              open: self.open,
              setOpen: self.handleBulkFlightDateChangeModalOpenChange,
              onSubmit: self.handleBulkFlightDateChangeSubmitted,
              type: self.type,
              selectedIds: self.selectedIds,
            },
          });
        });
      };

      this.$onInit = () => {
        self.renderReactComponent().then(() => {
          self.unregisterWatcher = $scope.$watchGroup(
            [
              "$bulkFlightDateChangeModalCtrl.open",
              "$bulkFlightDateChangeModalCtrl.selectedIds",
            ],
            ([_open, _selectedIds]) => {
              self.renderReactComponent();
            }
          );
        });
      };

      this.$onDestroy = () => {
        if (self.unregisterWatcher) {
          self.unregisterWatcher();
        }
      };

      $rootScope.$on("bulkEditBroadcast", (event, args) => {
        if (
          args.tableId === self.targetTableId &&
          args.id === "flight_date_change"
        ) {
          self.selectedIds = Array.isArray(args.selectedIds)
            ? args.selectedIds.slice()
            : [];
          self.open = true;
        }
      });
    },
  ],
});
